import { mergeArrays, replaceItem } from '../../helpers/helpers';
import * as type from '../actions/types';

const initialState = {
  errors: [],
  fetching: false,
  posting: false,
  success: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_FOOD_LIST_FOOD_ITEMS_PENDING:
      return {
        ...state,
        ...initialState,
        fetching: true,
        success: false,
        errors: [],
      };
    case type.FETCH_FOOD_LIST_FOOD_ITEMS_SUCCESS:
      return {
        ...state,
        fetching: false,
        success: true,
        errors: [],
        data: mergeArrays(state.data, action.payload?.data, 'id', true),
      };
    case type.FETCH_FOOD_LIST_FOOD_ITEMS_FAILURE:
      return {
        ...state,
        fetching: false,
        success: false,
        errors: action.payload,
      };
    case type.CREATE_FOOD_LIST_FOOD_ITEM_PENDING:
      return {
        ...state,
        posting: true,
        success: false,
        errors: [],
      };
    case type.CREATE_FOOD_LIST_FOOD_ITEM_FAILURE:
      return {
        ...state,
        posting: false,
        success: false,
        errors: action.payload,
      };
    case type.CREATE_FOOD_LIST_FOOD_ITEM_SUCCESS:
      console.log('game list game was created', action?.payload, state);
      const newItem = action?.payload;

      return {
        ...state,
        posting: false,
        success: true,
        errors: [],
        data: replaceItem(state.data, newItem, 'id', true),
      };
    case type.UPDATE_FOOD_LIST_FOOD_ITEM_SUCCESS:
      console.log('game list game was updated', action?.payload, state);
      const updatedItem = action?.payload?.data;

      return {
        ...state,
        posting: false,
        success: true,
        errors: [],
        data: replaceItem(state.data, updatedItem, 'id', true),
      };
    case type.UPDATE_FOOD_LIST_FOOD_ITEM_PENDING:
      return {
        ...state,
        posting: true,
        success: false,
        errors: [],
      };
    case type.UPDATE_FOOD_LIST_FOOD_ITEM_FAILURE:
      return {
        ...state,
        posting: false,
        success: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};
